import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type DevicesPanelEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const devicesPanelEntryPoint: EntryPoint<DevicesPanelEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<DevicesPanelEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-proactive-support-devices-panel" */ './DevicesPanel.tsx',
		),
		getPreloadProps: () => ({}),
	});
